var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{staticClass:"bg-marketing"}),_c('FeaturesV2'),_c('Benefits'),_c('Features'),_c('Newsletter'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }